export default function initContentAccordion() {
  const isPresent = document.querySelector(".content-accordion");
  if (!isPresent) {
    return;
  }

  const headers = document.querySelectorAll(".content-accordion-item__header");

  function openAccordion(e) {
    for (let i = 0; i < headers.length; i++) {
      const parent = headers[i].parentElement;
      const article = headers[i].nextElementSibling;

      if (this === headers[i] && !parent.classList.contains("open")) {
        parent.classList.add("open");

        article.style.maxHeight = `${article.scrollHeight}px`;
      } else {
        article.style.maxHeight = `0px`;

        setTimeout(function () {
          parent.classList.remove("open");
        }, 1);
      }
    }
  }

  for (let i = 0; i < headers.length; i++) {
    headers[i].addEventListener("click", openAccordion);
  }
}
